export default {
  FETCH_CURRENCY_COMBO: 'FETCH_CURRENCY_COMBO'
}
